import { createElement, useEffect, useState, useCallback } from 'react';
import { Select } from '@alifd/next';
import request from '@/utils/request';
const { Option } = Select;
const DictSelect = (props) => {
    const { initialValues, placeholder, value, onChange } = props;
    const [mapEnums, setMapEnums] = useState([]);
    const queryDict = useCallback(async () => {
        if (Array.isArray(initialValues) && initialValues.length > 0) {
            const dictTypeCd = initialValues.slice(-1)[0] || '';
            const { content } = await request(`/api/exchange/dictionary/type/parent/values/${dictTypeCd}`);
            const dataSource = content.map((item) => {
                return {
                    label: item.valDesc,
                    value: item.val,
                };
            });
            setMapEnums(dataSource);
        }
    }, []);
    useEffect(() => {
        queryDict();
    }, [queryDict]);
    return (createElement(Select, { placeholder: placeholder, onChange: onChange, style: { width: '100%' }, value: value }, mapEnums.map(({ label, value }) => {
        return (createElement(Option, { value: value, key: value }, label));
    })));
};
export default DictSelect;
